const blue =  {
	50: "#EAE9FC",
	100: "#C3C0F6",
	200: "#9D98F1",
	300: "#7770EB",
	400: "#5148E5",
	500: "#2A1FE0",
	600: "#2219B3",
	700: "#191386",
	800: "#110D59",
	900: "#08062D",
};

const white = {
	50: "#FFFFFF",
	100: "#efefef",
	200: "#dcdcdc",
	300: "#bdbdbd",
	400: "#989898",
	500: "#777777",
	600: "#656565",
	700: "#525252",
	800: "#464646",
	900: "#3d3d3d",
};

export const colors = {
	primary: white,
	secondary: blue,
};
